import { translateText } from 'utils';

export default {
  'OrderEvent.Button': ({ isOpen }, _, internalStateSetter) => {
    internalStateSetter({ isOpen: !isOpen })
  },
  'OrderEvent.Image': ({ url }, outlet) => {
    outlet({ action: 'view_media', url });
  },
  'OrderEvent.TranslateButton': async ({ translated, order_event, translation }, _, internalStateSetter) => {
    if (!translation) {
      const translatedText = await translateText(order_event.description)
      internalStateSetter({ translated: !translated, translation: translatedText })
    } else {
      internalStateSetter({ translated: !translated })
    }
  },
};
